import Basic from '@/layouts/Basic';

const router = [
    {
        path: '/error',
        component: Basic,
        meta: { auth: true },
        children: [
            {
                path: '/404',
                name: '404',
                component: () => import('@/views/errors/404'),
            },
            {
                path: '/403',
                name: '403',
                component: () => import('@/views/errors/403'),
            },
        ],
    },
    {
        path: '/device-blocked',
        component: Basic,
        children: [
            {
                path: '',
                name: 'device-blocked',
                component: () => import('@/views/errors/device_blocked'),
            },
        ],
    },
];

export default router;
